<template>
    <div class="main-bg">
        <Nav></Nav>

        <div class="content page-main-body-box">
            <FilterTwoClass v-show="!navLoading"
                            :scenes="scenes"
                            :categories="categories"
                            :cid="cid"
                            :child="child"
                            :scene="pagination.scene"
                            @change="filterChange"></FilterTwoClass>
            <template v-if="navLoading">
                <skeletonNav></skeletonNav>
                <skeletonNav2></skeletonNav2>
            </template>
            <template v-if="loading">
                <skeletonCourseList></skeletonCourseList>
            </template>
            <template v-else-if="courseList.length > 0">
                <div class="description">
        
                    <div  v-for="course in courseList" :key="course.id">
                        <CourseItem :cid="course.id"
                                    :thumb="course.thumb"
                                    :title="course.title"
                                    :rate="course.rate"
                                    :user-count="course.num"></CourseItem>
                    </div>
                </div>
            </template>
            <none v-else></none>
            <div id="page" v-show="courseList.length > 0 && total > pagination.size">
                <el-pagination v-if="loading"
                               @current-change="changepage"
                               :page-size="pagination.size"
                               background
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total">
                </el-pagination>
            </div>

        </div>

    </div>
</template>
<script>
    import Nav from "@/components/nav.vue";
    import None from "@/components/training/none.vue";
    import FilterTwoClass from "@/components/training/filter-two-class.vue";
    import SkeletonCourseList from "./components/skeletonCourseList.vue";
    import SkeletonNav from "./components/skeletonNav.vue";
    import SkeletonNav2 from "./components/skeletonNav2.vue";
    import CourseItem from "@/components/training/course-item.vue";

    export default {
        components: {
            Nav,
            CourseItem,
            FilterTwoClass,
            None,
            SkeletonCourseList,
            SkeletonNav,
            SkeletonNav2,
        },
        data() {
            return {
                pageName: "courses-list",
                scenes: [
                    {
                        id: "",
                        name: "全部",
                    },
                    {
                        id: "recommended",
                        name: "推荐",
                    },
                    {
                        id: "sub",
                        name: "热门",
                    },
                ],
                courseList: [
                    {
                        id: "1",
                        thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLB29sWmMcqW5XrmP6IibRZAmibyocfHtVnicEsicP3NavgrQAGGvQk9qWxhILwibT4ib4dJM/356",
                        title: "C#5-跨平台深度学习入门与项目实战",
                        num: "1233",
                        rate: 4,
                    },
                    {
                        id: "2",
                        thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAdmTbic5y5kwZmbP7TLa8A0iclQddeBk3UB4icEttskabIxLzhfYwl7dQjJ5wNQ7fFiac/356",
                        title: "超高效！新手必学的AE动效制作全流程",
                        num: "1233",
                        rate: 5,
                    },
                    {
                        id: "3",

                        thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLBhLOcxd2DWkjwWUXYvgZicLvU0S7gUWZM9m2RCbJbDvt3HViaG621wVcibfvmqk7NVGA/356",
                        title: "超高效！MYSQL增删改查操作实操",
                        num: "1233",
                        rate: 4,
                    },
                    {
                        id: "4",
                        thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLBhLOcxd2DWkjwWUXYvgZicLvU0S7gUWZM9m2RCbJbDvt3HViaG621wVcibfvmqk7NVGA/356",
                        title: "IOS+Swift零基础教程(带你玩转IOS)",
                        num: "1233",
                        rate: 4,
                    },
                    {
                        id: "5",
                        thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLCoNyJwbmOLtEXr8PA0UrSlhBIeLNgvTfCcOSWJdwFrRtH6YWuib0ROeIdy84PlBeVs/356",
                        title: "Java实战特训营",
                        num: "1233",
                        rate: 4,
                    },
                    {
                        id: "6",
                        thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAKAFJw1ypsCtU5TKsic6yycex2ZQSknichF6IIR1G8MribmgxUN9OgdzAjOk3iaeXlfxg/356",
                        title: "k8s&doceker实战",
                        num: "1233",
                        rate: 4,
                    },
                    {
                        id: "7",
                        thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLCUDBxXtW69z3jZ2zSGnytzAMfQXzw8UNibO2taIx1OpdBUwiaFJ1Lvyurnpg4arh2J0/356",
                        title: "C++基本介绍",
                        num: "1233",
                        rate: 4,
                    },
                    {
                        id: "8",
                        thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAkEriceW0qbqibMat9Jj2oiao7wSLoGtEjQvXgiaWyNteJ1FN1uDDKnDric4ticoickUz6OE/356",
                        title: "小程序应用与开发",
                        num: "1233",
                        rate: 4,
                    }
                ],
                total: null,
                pagination: {
                    page: 1,
                    size: 16,
                    scene: this.$route.query.scene || "",
                    category_id: 0,
                },
                categories: [
                    {
                        "id": 24,
                        "name": "使用教程",
                        "parent_id": 0,
                        "children": [
                            {
                                "id": 25,
                                "sort": 1,
                                "name": "测试1",
                                "parent_id": 24
                            }
                        ]
                    },
                    {
                        "id": 1,
                        "name": "前端开发",
                        "parent_id": 0,
                        "children": []
                    },
                    {
                        "id": 2,
                        "name": "后端开发",
                        "parent_id": 0,
                        "children": []
                    },
                    {
                        "id": 4,
                        "name": "移动开发",
                        "parent_id": 0,
                        "children": []
                    },
                    {
                        "id": 5,
                        "name": "人工智能",
                        "parent_id": 0,
                        "children": []
                    }
                ],
                loading: false,
                navLoading: false,
                cid: this.$route.query.cid || 0,
                child: this.$route.query.child || 0,
            };
        },
        mounted() {
            this.navLoading = true;
            this.getCategories();
            this.getData();
        },
        activated() {
            this.changefilter();
         /*   this.$utils.scrollTopSet(this.pageName);*/
        },
        beforeRouteLeave(to, from, next) {
           /* this.$utils.scrollTopRecord(this.pageName);*/
            next();
        },
        methods: {
            changefilter() {
                let cid1 = this.cid;
                let cid2 = this.child;
                let scene = this.pagination.scene;
                if (parseInt(cid1) === 0) {
                    this.$router.push({
                        path: this.$route.path,
                        query: {
                            scene: scene,
                        },
                    });
                } else {
                    this.$router.push({
                        path: this.$route.path,
                        query: {
                            cid: cid1,
                            child: cid2,
                            scene: scene,
                        },
                    });
                }
            },
            filterChange(cid1, cid2, scene) {
                if (parseInt(cid1) === 0) {
                    this.$router.push({
                        path: this.$route.path,
                        query: {
                            scene: scene,
                        },
                    });
                } else {
                    this.$router.push({
                        path: this.$route.path,
                        query: {
                            cid: cid1,
                            child: cid2,
                            scene: scene,
                        },
                    });
                }
                this.resetData();
                this.getData();
            },
            resetData() {
                this.list = [];
                this.pagination.page = 1;
            },
            changepage(item) {
                this.pagination.size = item.pageSize;
                this.pagination.page = item.currentPage;
                this.getData();
                window.scrollTo(0, 0);
            },
            //获取分类数据
            getCategories() {
                this.navLoading = false;
                //Api.Categories().then((res) => {
                //    this.navLoading = false;
                //    let categories = [];
                //    categories.push(...res.data);
                //    this.categories.push(...categories);
                //    this.filterChange(this.cid, this.child, this.scene);
                //});
            },
            //获取课程数据
            getData() {
                if (this.loading) {
                    return;
                }
                //this.loading = true;
                this.pagination.scene = this.$route.query.scene || "";
                this.cid = this.$route.query.cid || 0;
                this.child = this.$route.query.child || 0;
                if (parseInt(this.child) === 0) {
                    this.pagination.category_id = this.cid;
                } else {
                    this.pagination.category_id = this.child;
                }
                //Api.List(this.pagination).then((res) => {
                //    this.loading = false;
                //    let list = res.data.data;
                //    this.total = res.data.total;
                //    if (list.length > 0) {
                //        this.list = list;
                //    }
                //});
            }
           
        },
    };
</script>
<style lang="scss" scoped>
    .main-bg {
        background-image: url("../../../assets/home/backougnd.png");
        background-size: cover;
        overflow-x: hidden;

        .content {
            padding-top: 86px;
            max-width: 1300px;
            margin: 0 auto;
            text-align: center;


            .description {
            /*    width: 1360px;
                height: 651px;*/
                /*   align-items: center;
                justify-content: normal;
                margin: 24px 0px;
                display: flex; //把盒子在一行显示
                overflow-x: hidden; //超出隐藏
                flex-wrap: wrap; //超出自动换行*/
                width: 1300px;
                min-height: 651px;
                margin: 0 auto;
                display: grid;
                row-gap: 30px;
                column-gap: 48px;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                overflow: hidden;

                & .nothree {
                    justify-self: flex-start;
                }

                .group-item {
                    width: 305px;
                    height: 312px;
                    background: rgba(255,255,255,0.20);
                    border-image: linear-gradient(148deg, #ffffff 1%, #ffffff 90%) 2 2;
                    border-radius: 28px;
                    box-shadow: 1px 1px 1px 1px rgba(0,0,0,0.04);
                    transition: all .3s ease-in-out;
                    position: relative;
                    margin: 0px 12px;


                    &:hover {
                        bottom: 0px;
                        box-shadow: 0 4px 8px #6666661a;

                        .vod-course-thumb {
                            .thumb-bar {
                                transform: scale(1.1, 1.1);
                            }
                        }
                    }

                    .vod-course-thumb {
                        width: 305px;
                        height: 172px;
                        border-radius: 8px 8px 0px 0px;
                        overflow: hidden;

                        .thumb-bar {
                            width: 100%;
                            height: 100%;
                            transition: all .3s;
                        }
                    }

                    .item {
                        cursor: pointer;
                        padding: 16px 16px 8px 24px;
                    }


                    .name {
                        font-size: 18px;
                        // font-family: PingFangSC, PingFangSC-Medium;
                        font-weight: 700;
                        text-align: left;
                        color: #000000;
                        line-height: 22px;
                        margin: 12px 0;
                    }

                    .des {
                        display: flex;
                        position: relative;
                        align-items: center;
                        align-self: center;
                        margin-top: 23px;
                        justify-content: space-between;

                        .num {
                            width: 35px;
                            height: 17px;
                            font-size: 14px;
                            font-weight: 700;
                            text-align: left;
                            color: #666666;
                            line-height: 17px;
                        }

                        .word {
                            width: 42px;
                            height: 20px;
                            font-size: 14px;
                            font-weight: 400;
                            text-align: right;
                            color: #666666;
                            line-height: 20px;
                        }
                    }
                }
            }
        }
    }
</style>
